import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

@Injectable({
  providedIn: 'any',
})
export class QueryTypesContratGQLService extends Query<Response> {
  document = gql`
    query ReferentielTypesContrats {
      referentielTypesContrats {
        code
        libelle
      }
    }
  `;
}
